<template>
  <v-container>
    <v-layout v-if="searchStatus === false && categoryId >= 0">
      <v-layout row wrap class='products-list' v-if="getProductLists.length > 0">
        <v-flex v-for="prod in getProductLists" class="products-item" v-bind:class="calculateCardSize ? 'xs6': 'xs4'" v-bind:key="prod.id" v-on:click="showDetail(prod.id)">
          <v-card color="white" height="100%">
            <img v-bind:src='formatImagePath(prod.image_path, "350")' alt='Image' class='img'>
            <v-card-title>
              <p class="mb-0">{{ prod.product_name | productName }}</p>
            </v-card-title>
            <v-card-text>
              <v-flex>
                <span v-if='$i18n.locale() === "th"' class='sale-price'>{{ formatPrice(prod.normal_price, prod.special_price, prod.member_price) | currency(getCurrency.code, getCurrency.display, getCurrency.position, getCurrency.name_th) }}</span>
                <span v-else class='sale-price'>{{ formatPrice(prod.normal_price, prod.special_price, prod.member_price) | currency(getCurrency.code, getCurrency.display, getCurrency.position, getCurrency.name_en) }}</span>
              </v-flex>
              <v-flex v-if='prod.special_price || (prod.member_price && getParams.member === 1)'>
                <span v-if='$i18n.locale() === "th"' class='original-price'>{{ formatPrice(prod.normal_price) | currency(getCurrency.code, getCurrency.display, getCurrency.position, getCurrency.name_th) }}</span>
                <span v-else class='original-price'>{{ formatPrice(prod.normal_price) | currency(getCurrency.code, getCurrency.display, getCurrency.position, getCurrency.name_en) }}</span>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap v-else class='products-list text-xs-center products-not-found'>
        <v-flex xs6 offset-xs3>
          <v-card>
            <v-card-title primary-title class="text-xs-center">
              <div class="">{{ $t('product_category_not_found') }}</div>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
    </v-layout>
    <v-layout v-else>
      <v-layout row wrap class="products-list" v-if="getSearch.result !== 'not found products'">
        <v-flex v-bind:class="calculateCardSize ? 'xs6': 'xs4'" v-for='prod in getSearch.result.products' :key='prod.id' class="products-item" v-on:click='showDetail(prod.id)'>
          <v-card color="white" height="100%">
            <img :src='formatImagePath(prod.image_path, "350")' alt='Image' class='img'>
            <v-card-title>
              <p class="mb-0">{{ prod.product_name | productName }}</p>
            </v-card-title>
            <v-card-text>
              <v-flex>
                <span v-if='$i18n.locale() === "th"' class='sale-price'>{{ formatPrice(prod.normal_price, prod.special_price, prod.member_price) | currency(getCurrency.code, getCurrency.display, getCurrency.position, getCurrency.name_th) }}</span>
                <span v-else class='sale-price'>{{ formatPrice(prod.normal_price, prod.special_price, prod.member_price) | currency(getCurrency.code, getCurrency.display, getCurrency.position, getCurrency.name_en) }}</span>
              </v-flex>
              <v-flex v-if='prod.special_price || (prod.member_price && getParams.member === 1)'>
                <span v-if='$i18n.locale() === "th"' class='original-price'>{{ formatPrice(prod.normal_price) | currency(getCurrency.code, getCurrency.display, getCurrency.position, getCurrency.name_th) }}</span>
                <span v-else class='original-price'>{{ formatPrice(prod.normal_price) | currency(getCurrency.code, getCurrency.display, getCurrency.position, getCurrency.name_en) }}</span>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap v-else class='products-list text-xs-center products-not-found'>
        <v-flex xs6 offset-xs3>
          <v-card>
            <v-card-title primary-title class="text-xs-center">
              <div class="">{{ $t('product_not_found') }}</div>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
    </v-layout>
    <infinite-loading
      ref="infiniteLoading"
      v-if="getProductsResult.list.length > 0"
      spinner="spiral"
      v-on:infinite="handleScroll"
    >
      <span slot="no-results"></span>
      <span slot="no-more"></span>
    </infinite-loading>
  </v-container>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import getSymbolFromCurrency from 'currency-symbol-map'
import InfiniteLoading from 'vue-infinite-loading'

export default {
  name: 'ProductList',
  data () {
    return {
      page: 1,
      oldScroll: 0,
      enableInfiniteScroll: false,
      currentSearchStatus: false,
      currentCategory: 0
    }
  },
  components: {
    InfiniteLoading
  },
  computed: {
    ...mapGetters([
      'getProductLists',
      'getCategories',
      'getCurrency',
      'getSearch',
      'getParams',
      'getProductsResult'
    ]),
    searchOldScroll () {
      return this.getSearch.scroll
    },
    calculateCardSize () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return true
      } else {
        return false
      }
    },
    searchStatus () {
      if (this.enableInfiniteScroll === true &&
        this.getSearch.status !== this.currentSearchStatus
      ) {
        this.setEnableInfiniteScroll(false)
        this.$refs.infiniteLoading.stateChanger.reset()
      }
      this.setCurrentSearchStatus(this.getSearch.status)

      // return this.getSearch.status
      return this.currentSearchStatus
    },
    categoryId () {
      if (this.enableInfiniteScroll === true && this.getCategories.currentId !== this.currentCategory) {
        this.setEnableInfiniteScroll(false)
        this.$refs.infiniteLoading.stateChanger.reset()
      }
      this.setCurrentCategory(this.getCategories.currentId)

      // return this.getCategories.currentId
      return this.currentCategory
    }
  },
  methods: {
    ...mapActions([
      'setProductLists',
      'getApiImageUrl',
      'searchMoreProducts',
      'setSearchOldScroll',
      'setMoreSearch'
    ]),
    setCurrentSearchStatus (value) {
      this.currentSearchStatus = value
    },
    setEnableInfiniteScroll (value) {
      this.enableInfiniteScroll = value
    },
    setCurrentCategory (value) {
      this.currentCategory = value
    },
    formatPrice (normalPrice, specialPrice, memberPrice) {
      var value = ''
      if (memberPrice && this.getParams.member === 1) {
        value = memberPrice
      } else if (specialPrice) {
        value = specialPrice
      } else {
        value = normalPrice
      }

      let val = (value / 1).toFixed(2).replace(', ', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    handleScroll ($state) {
      if (this.getSearch.status === false) {
        if (parseInt(this.getProductsResult.page.number) < parseInt(this.getProductsResult.page.page_count)) {
          this.enableInfiniteScroll = true
          var str = '?_page=' + (parseInt(this.getProductsResult.page.number) + 1) + '&_limit=12&_sort=id&_order=desc&type=categoryPage'
          var param = {'categoryId': this.getCategories.list.parent.id, 'queryString': str, 'loadMore': true}
          this.setProductLists(param).then(results => {
            results.forEach((element, index) => {
              this.getProductLists.push(element)
            })
            $state.loaded()
          })
        } else if (this.enableInfiniteScroll === true && this.currentSearchStatus === false) {
          $state.complete()
        } else {
          this.enableInfiniteScroll = true
          $state.reset()
        }
      } else {
        if (parseInt(this.getSearch.result.page.number) < parseInt(this.getSearch.result.page.page_count)) {
          this.enableInfiniteScroll = true
          this.setMoreSearch()
          this.searchMoreProducts().then(results => {
            $state.loaded()
          })
        } else if (this.enableInfiniteScroll === true && this.currentSearchStatus === true) {
          $state.complete()
        } else {
          this.enableInfiniteScroll = true
          $state.reset()
        }
      }
    },
    showDetail (staticUrl) {
      this.$router.push({name: 'ProductDetail', params: { staticUrl: staticUrl }})
    },
    formatImagePath (image, size) {
      return process.env.IMAGE_SERVICE_URL + '/image/' + size + 'x0/' + image
    }
  },
  filters: {
    currency (value, code, display, position, name) {
      var text = ''
      if (display === 'iso') {
        text = code
      } else if (display === 'symbol') {
        text = getSymbolFromCurrency(code)
      } else {
        text = name
      }
      if (position === 'prefix') {
        return text + ' ' + value
      } else {
        return value + ' ' + text
      }
    },
    productName (value) {
      if (value.length > 42) {
        return value.substr(0, 41) + '...'
      } else {
        return value
      }
    },
    created () {
      var str = '?_page=' + (parseInt(this.getProductsResult.page.number) + 1) + '&_limit=12&_sort=id&_order=desc&type=categoryPage'
      var param = {'categoryId': this.getCategories.list.parent.id, 'queryString': str, 'loadMore': true}
      this.setProductLists(param).then(results => {
        results.forEach((element, index) => {
          this.getProductLists.push(element)
        })
      })
    }
  }
}
</script>

<style type='text/css' lang='scss' scoped>
  .container {
    padding: 111px 7px 7px;

    .products-item {
      padding: 7px;
    }
    .products-not-found {
      width: 100%;
      height: 78vh;
      align-items: center;
      display: flex;
      .text-xs-center {
        display: block;
        padding: 10px !important;
      }
    }
    .card {
      background-color: #fff;
      .img {
        width: 100%;
      }
      .card__title {
        padding: 5px;
        word-break: break-word;
      }
      .card__text {
        padding: 0 5px 5px 5px;
        .sale-price {
          color: green;
          font-size: 16px;
        }
        .original-price {
          font-size: 12px;
          color: gray;
          text-decoration: line-through;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shopCategory/productsList/ProductList.vue